// extracted by mini-css-extract-plugin
export default {"container":"ClosedCashRegisterModal_container__d8ByS","warning":"ClosedCashRegisterModal_warning__ZPdsn"};